import { render, staticRenderFns } from "./TechCheckPassedFailPopup.vue?vue&type=template&id=b2ad6fc0&scoped=true"
import script from "./TechCheckPassedFailPopup.vue?vue&type=script&lang=js"
export * from "./TechCheckPassedFailPopup.vue?vue&type=script&lang=js"
import style0 from "./TechCheckPassedFailPopup.vue?vue&type=style&index=0&id=b2ad6fc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ad6fc0",
  null
  
)

export default component.exports